import { openDb } from 'idb';
import { getUserId } from './utils';

const dbPromise = function (userId) {

  return openDb(`keyvet-store-${userId}`, 1, upgradeDB => {
    let dbNames = [
      'errors',
      'winter-consult',
      'spring-consult',
      'spring-review',
      'dry-cow-consult',
      'general-farm-consult',
    ]

    for (let dbName of dbNames) {
      if (!upgradeDB.objectStoreNames.contains(dbName)){
        upgradeDB.createObjectStore(dbName);
      }
    }
  });
};

const DEFAULT_STORE = 'winter-consult'

export const indexedDB = {

  async get(key, storeName) {
    if (!storeName) { storeName = DEFAULT_STORE }

    const userId = getUserId()
    if (userId == undefined) {return}
    const db = await dbPromise(userId);
    return db.transaction(storeName).objectStore(storeName).get(key);
  },
  async set(key, val, storeName) {
    if (!storeName) { storeName = DEFAULT_STORE }
    const userId = getUserId()
    if (userId == undefined) {return}
    const db = await dbPromise(userId);
    const tx = db.transaction(storeName, 'readwrite');
    tx.objectStore(storeName).put(val, key);
    return tx.complete;
  },
  async delete(key, storeName) {
    if (!storeName) { storeName = DEFAULT_STORE }
    const userId = getUserId()
    if (userId == undefined) {return}
    const db = await dbPromise(userId);
    const tx = db.transaction(storeName, 'readwrite');
    tx.objectStore(storeName).delete(key);
    return tx.complete;
  },
  async clear(storeName) {
    if (!storeName) { storeName = DEFAULT_STORE }
    const userId = getUserId()
    if (userId == undefined) {return}
    const db = await dbPromise(userId);
    const tx = db.transaction(storeName, 'readwrite');
    tx.objectStore(storeName).clear();
    return tx.complete;
  },
  async keys(storeName) {
    if (!storeName) { storeName = DEFAULT_STORE }
    const userId = getUserId()
    if (userId == undefined) {return}
    const db = await dbPromise(userId);
    return db.transaction(storeName).objectStore(storeName).getAllKeys();
  },
  async getAll(storeName) {
    if (!storeName) { storeName = DEFAULT_STORE }
    const userId = getUserId()
    if (userId == undefined) {return}
    const db = await dbPromise(userId);
    return db.transaction(storeName).objectStore(storeName).getAll();
  }
};
